import { checkLsuForMatieres } from '@teetsh/app/src/containers/Livrets/queries/checkLsuForMatieres';
import {
  LivretEleve,
  LivretEleveMatiere,
  LSUErrorCode,
  TypePositionnement,
} from '@teetsh/app/src/containers/Livrets/types/livret';
import { ErrorLabelAction } from 'containers/Livrets/useLSUErrorsMapping';

const recomputedError: LSUErrorCode[] = [
  'no_competences',
  'should_have_3_completed_domains',
  'domain_has_no_competences_but_a_note',
  'too_long_competence_name',
  'empty_competence_name',
];

export function updateMatiereLivretEleve(
  livretEleve: LivretEleve,
  matiere: LivretEleveMatiere,
  typePositionnement: TypePositionnement,
  errorsMapping: (
    error: LSUErrorCode,
    params?: {
      [key: string]: string;
    },
  ) => ErrorLabelAction | undefined,
): LivretEleve {
  const matieres = livretEleve.matieres.map(oldMatiere => {
    if (oldMatiere.id === matiere.id) {
      return matiere;
    }
    return oldMatiere;
  });
  const errors = checkLsuForMatieres(
    matieres,
    typePositionnement,
    errorsMapping,
  );
  return {
    ...livretEleve,
    matieres,
    lsuErrors: [
      ...livretEleve.lsuErrors.filter(
        error => !recomputedError.includes(error.code),
      ),
      ...errors,
    ],
  };
}
